var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRoleResponsibilities(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Role_Icon",
    "data-name": "Role Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 16,
    height: 16,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2 1.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5778",
    "data-name": "Path 5778",
    d: "M9.43,8.343A4.176,4.176,0,1,1,13.6,4.166,4.176,4.176,0,0,1,9.43,8.343ZM9.43.71a3.459,3.459,0,1,0,3.459,3.456A3.459,3.459,0,0,0,9.43.71Z",
    transform: "translate(-3.459 0.01)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5779",
    "data-name": "Path 5779",
    d: "M.343,31.606a.34.34,0,0,1-.187-.054.34.34,0,0,1-.116-.493l1.268-2.039A2.12,2.12,0,0,1,3.12,28h5.7a2.134,2.134,0,0,1,1.777.952l1.373,2.107a.358.358,0,0,1-.595.4L10,29.386a1.417,1.417,0,0,0-1.176-.642H3.12a1.414,1.414,0,0,0-1.206.68L.666,31.436a.364.364,0,0,1-.323.17Z",
    transform: "translate(0.02 -18.482)",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoleResponsibilities);
export default __webpack_public_path__ + "static/media/icon_role_responsibilities.1ecfd31d6534aaa92f5d65afb84b0ca4.svg";
export { ForwardRef as ReactComponent };